import { useSyncExternalStore } from 'react'

const DARK_MODE_KEY = 'peps-dark-mode'

const subscribers = new Set<() => void>()

function subscribe(callback: () => void) {
  subscribers.add(callback)
  return () => { subscribers.delete(callback) }
}

function getSnapshot(): boolean {
  const stored = localStorage.getItem(DARK_MODE_KEY)
  return stored === null ? false : stored === 'true'
}

function toggleDark() {
  const current = getSnapshot()
  localStorage.setItem(DARK_MODE_KEY, String(!current))
  subscribers.forEach((cb) => cb())
}

export function useDarkMode() {
  const isDark = useSyncExternalStore(subscribe, getSnapshot)
  return { isDark, toggleDark }
}
